<template>
  <div class="impressum">
    <div class="content">
      <h1>Impressum</h1>
      <div class="impressum-text">
        <p class="description" v-html="text"></p>
        <div class="sources-wrapper">
          <p><strong>Datenquellen</strong></p>
          <div class="sources">
            <p v-html="srcTextText"></p>
            <p v-html="srcIlluText"></p>
            <p v-html="srcImgText"></p>
          </div>
        </div>
      </div>
    </div>
    <svg class="wave" viewBox="0 0 1440 154" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M481 85.4999C169.741 169.413 173.5 -9.57918 0 1.00002V306.459L1436.94 336C1444.46 222 1458.8 -1.90006 1456 14.4999C1453.2 30.8999 1359 99.4999 1234 99.4999C1109 99.4999 929.5 54.9999 799 46.4999C694.6 39.6999 543.5 66.6666 481 85.4999Z" fill="#1CA0BE"/>
    </svg>
    <div id="lightRays">
      <div class="lightRay"></div>
      <div class="lightRay"></div>
      <div class="lightRay"></div>
    </div>
  </div>
</template>

<style lang="scss">
.impressum {
  height: 100vh;
  background: linear-gradient(360deg, #C6E3E4 0%, #CCEBEC 63.01%, #F7F7EB 100%);
  .content {
    font-weight: 400;
    line-height: 25px;
    color: #4d4d4d;
    padding-top: 16vh;
    p {
      margin: 0;
    }
    .impressum-text {
      display: flex;
      .description {
        width: 40%;
      }
      .sources-wrapper {
        width: 60%;
        .sources {
          display: flex;
          justify-content: space-between;
          p {
            width: 30%;
          }
        }
      }
    }
  }
  .wave {
    width: 100vw;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>

<script>
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

import contentfulClient from "@/module/contentful";

export default {
  name: 'Impressum',
  data() {
    return {
      text: "",
      srcTextText: "",
      srcImgText: "",
      srcIlluText: "",
    };
  },
  created: async function() {
    const result = await contentfulClient.getEntry("3PlOR0tSQE6dTDCgOzt6gP");
    this.text = documentToHtmlString(result.fields.impressum.content[0]).replace(/\n/g, `</br>`);
    this.srcIlluText = documentToHtmlString(result.fields.impressumSrcIllu.content[0]).replace(/\n/g, `</br>`);
    this.srcImgText = documentToHtmlString(result.fields.impressumSrcImg.content[0]).replace(/\n/g, `</br>`);
    this.srcTextText = documentToHtmlString(result.fields.impressumSrcText.content[0]).replace(/\n/g, `</br>`);
  },
  mounted: async function() {
  }
}
</script>
